<template>
  <div class="container">
    <div class="search-button-inside form-light">
      <form class="" role="search">
        <label class="search-label visually-hidden" for="search">
          <span>Search events</span>
        </label>
        <input
          class="search-input"
          id="search"
          type="text"
          placeholder="Search events"
          name="q"
          autocorrect="off"
          v-model="searchString"
          @keydown.13.prevent="parseSearchString"
        />

        <button @click="parseSearchString" class="submit-button" type="button">
          <span class="icon-search"></span>
        </button>
      </form>
    </div>
    <a href="javascript:;" class="button flat clear-search" 
        v-if="searchString"
        @click.prevent="clearSearch"
      >Clear <i class="icon-cross"></i
    ></a>

    <!-- 
    <form class="form">
      <div class="form-wrap">
        <input
          v-model="searchString"
          @keydown.13.prevent="parseSearchString"
          type="text"
          class="form-control"
          placeholder="Search events"
        />

        <button
          @click="parseSearchString"
          class=""
          type="button"
        >
          <i class="fas fa-search"></i> Search
        </button>
      </div>
    </form> -->
  </div>
</template>

<script>
export default {
  name: "SearchForm",
  data() {
    return {
      searchString: "",
    };
  },
  methods: {
    parseSearchString() {
      // Trim search string
      const trimmedSearchString = this.searchString.trim();

      if (trimmedSearchString !== "") {
        // Split search string
        const searchParams = trimmedSearchString.split(/\s+/);
        // Emit event
        this.$emit("search", searchParams);
        // Reset input field
        // this.searchString = '';
      }
    },
    clearSearch() {
      this.searchString = '';
      this.$emit("search", '');
      console.log('clear');
    }
  },
};
</script>

<style scoped lang="scss">
input,
button {
  box-shadow: none !important;
}

.form-control {
  border-color: #6c757d;
}
.clear-search {
  color: #AF1B1B;
  padding-left: 0;
  text-decoration: none;
  
  &:hover,
  &:active,
  &:focus {
    color: #AF1B1B;
    opacity: .9;
  }
}

</style>